import { MediaConfig } from "core/leaves/Media";
import { Entity, ProductByIdDocument } from "gql/generated";

export const productMediaConfig: MediaConfig = {
  query: ProductByIdDocument,
  entityType: Entity.Product,
};
